import { t } from 'i18next'

import BodyText from 'libs/shared/ui/src/lib/components/generics/body-text'
import DSTitle from 'libs/shared/ui/src/lib/components/generics/ds-title'
import EvolutionCognitiveBarChart from './Charts/EvolutionCognitiveBarChart'

interface NutritionalChartsProps {
  handleModalToggle: () => void
  title: string
  modalLink: string
  chartDescription: string
  error: unknown
  data: any
  chartTitle: string
  noScoresInChart: boolean
}

const cognitiveCharts = ({
  handleModalToggle,
  title,
  modalLink,
  chartDescription,
  error,
  data,
  chartTitle,
  noScoresInChart,
}: NutritionalChartsProps) => {
  return (
    <div className="flex flex-col gap-8">
      {noScoresInChart ? null : (
        <div className="flex flex-col w-full bg-neutral-100 rounded-lg p-6 lg:p-10 min-h-[638px] font-aeonik text-generic-neutral-900">
          <DSTitle className="mb-4 text-[#333333]">{title}</DSTitle>
          <BodyText
            className="underline mb-4 cursor-pointer"
            onClick={handleModalToggle}
          >
            {modalLink}
          </BodyText>
          <DSTitle className="my-4">{chartTitle}</DSTitle>
          <BodyText className="mb-5">{chartDescription}</BodyText>
          {error ? (
            <div className="flex justify-center items-center h-full text-center">
              <p>
                {t('myEvolution.resultsDescription.fetchError1')} <br />
                {t('myEvolution.resultsDescription.fetchError2')}
              </p>
            </div>
          ) : (
            <div className="flex flex-col">
              <EvolutionCognitiveBarChart data={data} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default cognitiveCharts
